<template>
  <div id="app">
    <!--<router-view name="header"></router-view>-->
    <router-view name="sideBar"></router-view>
    <router-view :style="stylestr"></router-view>
    <router-view name="footer"></router-view>
  </div>
</template>

<script>
import loginapi from './api/login'
export default {
  name: 'App',
  data () {
    return {
      stylestr: 'padding-left:170px;'
    }
  },
  mounted () {
    console.log(this.$commonfun.localStorage.getitem('qyuser'))
    if (this.$commonfun.localStorage.getitem('qyuser') === 'true') {
      let urlstr
      if (window.location.href.indexOf('#') === -1) {
        urlstr = window.location.href
      } else {
        urlstr = window.location.href.slice(0, window.location.href.indexOf('#'))
      }
      loginapi.getUserAgentconfig('get', '/user/agentconfig?url=' + this.$commonfun.encodeUrl(urlstr))
        .then(result2 => {
          window.wx.agentConfig({
            beta: true,
            corpid: result2.data.corpId, // 必填，企业微信的corpid，必须与当前登录的企业一致
            agentid: result2.data.agentId, // 必填，企业微信的应用id （e.g. 1000247）
            timestamp: result2.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: result2.data.nonceStr, // 必填，生成签名的随机串
            signature: result2.data.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
            jsApiList: ['selectExternalContact', 'selectEnterpriseContact', 'openUserProfile', 'selectCorpGroupContact'], // 必填，传入需要使用的接口名称
            success: (result) => {
              //  wx.agentConfig成功回调后，WWOpenData 才会注入到 window 对象上面
              window.WWOpenData.bind(document.querySelector('ww-open-data'))
            },
            fail: (res) => {
              console.log('查看错误信息' + JSON.stringify(res))
            }
          })
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  watch: {
    $route (to, from) {
      if (to.path === '/login') {
        this.stylestr = 'padding-left:0;'
      } else {
        if (to.query.navisshow && (to.query.navisshow === 'true' || to.query.navisshow === true)) {
          this.stylestr = 'padding-left:74px;'
        } else {
          this.stylestr = 'padding-left:170px;'
        }
      }
    }
  }
}
</script>

<style>
*{
margin: 0;
padding: 0;
}
body, html{
width: 100%;
height: 100%;
overflow: hidden;
}
#app {
  font-family: 'PingFangSC-Regular,PingFang SC';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  height: 100%;
  width: 100%;
}
@font-face {
  font-family: 'iconfont';
  src: url('./assets/iconfont/iconfont.eot');
  src: url('./assets/iconfont/iconfont.eot?#iefix') format('embedded-opentype'),
      url('./assets/iconfont/iconfont.woff2') format('woff2'),
      url('./assets/iconfont/iconfont.woff') format('woff'),
      url('./assets/iconfont/iconfont.ttf') format('truetype'),
      url('./assets/iconfont/iconfont.svg#iconfont') format('svg');
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body .el-table th.gutter{
  display: table-cell!important;
}
body .el-table colgroup.gutter{
  display: table-cell!important;
}
/*解决table头部部分字段没有排序的时候导致的高度不一致*/
.el-table th>.cell{
  height: 34px;
  line-height: 34px;
}
/* 进度条loading修改颜色 */
 #nprogress .bar {
  background: #3bc6b9 !important;
}
/* textarea 字体样式修改 */
.el-textarea__inner{
  font: 400 13.3333px Arial;
}
/* 消息提示 */
.el-tooltip__popper {
  max-width: 300px;
}
.popper-class{
 background-color:#fff;
}
.el-dialog{
  width: 35% !important;
}
.mouseActive{
  background: #f5f7fa;
}
/*.el-table__fixed-body-wrapper{
  height: calc(100% - 68px) !important;
}*/
.el-table__fixed-right{
  right: 10px !important;
}
.el-tabs--card>.el-tabs__header{
  border-bottom: 0 !important;
}
.addCommon .return{
  border-top: 1px solid #f2f2f2;
}
.addCommon .left{
  width: 320px !important;
}
.addCommon .el-icon-s-fold{
  display: none;
}
.el-dialog__body{
  padding-top: 10px !important;
}
.el-dialog__body::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.el-dialog__body::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
  background: #E1E1E1;
}
.el-dialog__body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  background: #fff;
}
.el-button--danger{
  border:1px solid #3BC6B9 !important;
  color:#3BC6B9 !important;
}
.el-button--danger.is-disabled, .el-button--danger.is-disabled:active, .el-button--danger.is-disabled:focus, .el-button--danger.is-disabled:hover{
  color: #C0C4CC !important;
  cursor: not-allowed !important;
  background-image: none !important;
  background-color: #FFF !important;
  border-color: #EBEEF5 !important;
}
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner{
  background-color: #c0c4cc !important;
  border-color: #c0c4cc !important;
}
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
  border-color: #fff !important;
}
.el-table:not(.el-table--scrollable-y) .el-table__fixed-right{
  right: 0 !important;
}
.el-table .el-table__fixed-right{
  height: 100% !important;
}
.el-table.el-table--scrollable-x .el-table__fixed-right .el-table__fixed-body-wrapper{
  height: calc(100% - 70px) !important;
}
.el-table:not(.el-table--scrollable-x) .el-table__fixed-right .el-table__fixed-body-wrapper{
  height: calc(100% - 60px) !important;
}
.el-tabs__header.is-top {
  width: calc(100% - 140px);
}
</style>
